<script setup lang="ts">
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfacePostsStore } from '@@/pinia/surface_posts'
import type { Id } from '@@/types'
import SurfaceHeader from '@@/vuecomponents/SurfaceHeader.vue'
import SurfacePostsGridMasonry from '@@/vuecomponents/SurfacePostsGridMasonry.vue'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'

withDefaults(
  defineProps<{
    reactionIdsByPostId: Record<Id, Id[]>
    commentIdsByPostId: Record<Id, Id[]>
  }>(),
  {
    reactionIdsByPostId: () => ({}),
    commentIdsByPostId: () => ({}),
  },
)

defineEmits(['scroll'])

const { xHeader, backgroundLuminance, isReadOnly, isScreenshotMode } = storeToRefs(useSurfaceStore())
const { allSortedPosts } = storeToRefs(useSurfacePostsStore())

const wallContainer = ref<HTMLDivElement>()
</script>

<template>
  <div
    id="wall-container"
    ref="wallContainer"
    :class="[
      !isReadOnly && 'overflow-x-hidden',
      !isScreenshotMode && 'scrollbar-overlay',
      {
        'scrollbar-photo': backgroundLuminance === 'light',
        'scrollbar-photo-dark': backgroundLuminance === 'dark',
        'scrollbar-gutter-stable': true,
      },
    ]"
    @scroll="$emit('scroll')"
  >
    <SurfaceHeader v-if="xHeader" />
    <SurfacePostsGridMasonry
      v-if="wallContainer"
      :reaction-ids-by-post-id="reactionIdsByPostId"
      :comment-ids-by-post-id="commentIdsByPostId"
      :posts="allSortedPosts"
      :wall-container="wallContainer"
    />
  </div>
</template>
